const OnEscape = function (ev) {
  if (ev.keyCode === 27) {
    this.editUser.hideModal()
  }
}

export default OnEscape
